module.exports = {"513322100":"泸桥镇","513322101":"冷碛镇","513322102":"兴隆镇","513322103":"磨西镇","513322104":"燕子沟镇","513322105":"得妥镇","513322106":"烹坝镇","513322107":"德威镇","513322200":"岚安乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513322.json
// module id = 2544
// module chunks = 0